module.exports = __webpack_public_path__ + "img/success.6546f777.png";